import React, { useState, useEffect } from "react";
import { Modal } from "react-bootstrap";
import IconButton from "@mui/material/IconButton";
import Swal from "sweetalert2";
import { IoMdAdd } from "react-icons/io";
import Hexapi from "../usefulcomps/HexAPI/Hexapi";
import axios from "axios";

function PurchaseOrderForm(props) {
  const [showmodal, setshowmodal] = useState(false);
  const [modalLoading, setModalLoading] = useState(true);
  const [
    OpportunityReferenceNumberDisable,
    setOpportunityReferenceNumberDisable,
  ] = useState(true);
  const [OpportunityReferenceNumber, setOpportunityReferenceNumber] =
    useState("");
  const [SapID, setSapID] = useState("");
  const [Supplier, setSupplier] = useState("");

  useEffect(() => {
    console.log(props.disabled);
  }, [props.disabled]);

  const getdata = async () => {
    setModalLoading(true);
    let obj = {
      query: `[dbo].[CRM_Proc_PurchaseOrder_GetData] @agentID='{0}', @EnquiryID='{1}'`,
      queryArr: [`${props.AgentID}`, `${props.enquiryID}`],
    };
    try {
      const resp = await Hexapi(obj);
      console.log(resp);
      setOpportunityReferenceNumber(resp[""][0]["opportunityreferencenumber"]);
      setOpportunityReferenceNumberDisable(
        resp[""][0]["opportunityreferencenumberdisable"],
      );
      setSapID(resp[""][0]["sapid"] || "");
      setSupplier(resp[""][0]["supplier"] || "");
      setModalLoading(false);
    } catch (err) {
      console.error("Error fetching purchase order data:", err);
    } finally {
      setModalLoading(false);
    }
  };

  const submit = async () => {
    if (
      OpportunityReferenceNumber === "" ||
      OpportunityReferenceNumber === null ||
      OpportunityReferenceNumber === undefined
    ) {
      Swal.fire({
        icon: "warning",
        title: "Required",
        text: "Please enter Opportunity Reference Number.",
      });
      return;
    }
    if (!SapID) {
      Swal.fire({
        icon: "warning",
        title: "Required",
        text: "Please enter SAP ID.",
      });
      return;
    }
    if (!Supplier) {
      Swal.fire({
        icon: "warning",
        title: "Required",
        text: "Please enter Supplier.",
      });
      return;
    }

    setModalLoading(true);
    let obj = {
      query: `[dbo].[CRM_Proc_PurchaseOrder_Submit] 
        @agentID='{0}', 
        @EnquiryID='{1}', 
        @OpportunityReferenceNumber='{2}', 
        @SapID='{3}', 
        @Supplier='{4}'`,
      queryArr: [
        `${props.AgentID}`,
        `${props.enquiryID}`,
        `${OpportunityReferenceNumber}`,
        `${SapID}`,
        `${Supplier}`,
      ],
    };

    try {
      const resp = await Hexapi(obj);

      if (resp?.[""]?.[0]?.command === 1) {
        const postData = {
          ServiceCharge: resp[""][0]["servicecharge"],
          TransportationCost: resp[""][0]["transportationcost"],
          Discount: resp[""][0]["discount"],
          EnquiryID: props.enquiryID,
          Today: new Date().toLocaleDateString("en-GB"),
          OpportunityReferenceNumber: resp[""][0]["opportunityreferencenumber"],
          Validity: formatDate(resp[""][0]["validity"]),
          CompanyName: resp[""][0]["companyname"],
          OfficeAddress: resp[""][0]["officeaddress"],
          SiteAddress: resp[""][0]["siteaddress"],
          City: resp[""][0]["city"],
          GstNumber: resp[""][0]["gstnumber"],
          EmailID: resp[""][0]["emailid"],
          CustomerName: resp[""][0]["customername"],
          Rating: resp[""][0]["rating"],
          OtherSpecifications: resp[""][0]["otherspecifications"],
          Pincode: resp[""][0]["pincode"],
          Panel: resp[""][0]["panel"],
          State: resp[""][0]["state"],
          Qty: resp[""][0]["qty"],
          EngineModel: resp[""][0]["enginemodel"],
          Quotation: resp[""][0]["quotation"],
          QuotationID: resp[""][0]["quotationid"],
          ContactNumber: resp[""][0]["contactnumber"],
          Revision: resp[""][0]["revisionno"],
          SapID: SapID,
          Supplier: Supplier,
        };

        const res = await fetch(`${process.env.PUBLIC_URL}/Apiinfo.json`);
        const data = await res.json();
        if (!data?.apipath) throw new Error("API Path missing");

        const url = `${data.apipath}SendPurchaseOrder.php`;

        const response = await axios.post(url, postData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });

        // ✅ SUCCESS SWAL
        await Swal.fire({
          icon: "success",
          title: "Purchase Order Sent",
          text: "Purchase order has been sent successfully.",
          confirmButtonText: "OK",
        });

        setshowmodal(false);
        props.RefreshLogs();
      }
    } catch (error) {
      console.error(error);
      Swal.fire({
        icon: "error",
        title: "Failed",
        text:
          error?.response?.data?.message ||
          error.message ||
          "Something went wrong while submitting purchase order",
      });
    } finally {
      setModalLoading(false);
    }
  };

  const formatDate = (dateInput) => {
    if (!dateInput) return "";

    // Handle SQL date wrapper objects like { date: '2026-06-08 00:00:00.000' }
    if (typeof dateInput === "object" && dateInput !== null && dateInput.date) {
      dateInput = dateInput.date;
    }

    let d = null;

    if (dateInput instanceof Date) {
      d = dateInput;
    } else {
      let s = String(dateInput).trim();

      // Convert common SQL datetime "YYYY-MM-DD HH:MM:SS(.mmm)" to ISO by replacing space with 'T'
      // e.g. "2026-06-08 00:00:00.000" -> "2026-06-08T00:00:00.000"
      if (/^\d{4}-\d{2}-\d{2}\s\d{2}:\d{2}:\d{2}/.test(s)) {
        s = s.replace(" ", "T");
      }

      d = new Date(s);

      // Fallback: if still invalid, try constructing from Y-M-D parts (ignore time)
      if (isNaN(d.getTime())) {
        const datePart = s.split("T")[0].split(" ")[0];
        const parts = datePart.split("-");
        if (parts.length === 3) {
          const y = Number(parts[0]);
          const m = Number(parts[1]);
          const day = Number(parts[2]);
          if (!Number.isNaN(y) && !Number.isNaN(m) && !Number.isNaN(day)) {
            d = new Date(y, m - 1, day);
          }
        }
      }

      if (!d || isNaN(d.getTime())) return "";
    }

    return (
      String(d.getDate()).padStart(2, "0") +
      "/" +
      String(d.getMonth() + 1).padStart(2, "0") +
      "/" +
      d.getFullYear()
    );
  };

  return (
    <>
      <button
        disabled={props.disabled}
        onClick={() => {
          setshowmodal(true);
          getdata();
        }}
        style={{
          background: "none",
          border: "none",
          padding: 0,
          cursor: props.disabled ? "not-allowed" : "pointer",
        }}
      >
        <IoMdAdd
          style={{ color: "grey", fontSize: "25px" }}
          title="Add Purchase Order"
        />
      </button>
      <Modal
        show={showmodal}
        onHide={() => setshowmodal(false)}
        dialogClassName="custom-modall-quote"
        size="lg"
        scrollable
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton style={{ backgroundColor: "#f5f9ff" }}>
          <div className="w-100">
            <div>
              <strong>Purchase Order Form</strong>
            </div>
            <div className="d-flex gap-4 mt-2">
              <span>
                <strong>EnquiryID:</strong> {props.enquiryID}
              </span>
              <span>
                <strong>CustomerName:</strong> {props.customerName}
              </span>
            </div>
          </div>
        </Modal.Header>

        <Modal.Body>
          {!modalLoading ? (
            <>
              <form className="p-3 mx-auto" style={{ maxWidth: "720px" }}>
                <div className="row g-3">
                  <div className="col-10">
                    <label className="form-label">Opportunity Ref. No.</label>
                    <span className="text-danger">*</span>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter reference number"
                      value={OpportunityReferenceNumber}
                      onChange={(e) =>
                        setOpportunityReferenceNumber(e.target.value)
                      }
                      disabled={OpportunityReferenceNumberDisable}
                      required
                    />
                  </div>
                  <div className="col-md-6">
                    <label className="form-label">SAP ID</label>
                    <span className="text-danger">*</span>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter SAP ID"
                      value={SapID}
                      onChange={(e) => setSapID(e.target.value)}
                      required
                    />
                  </div>

                  <div className="col-md-6">
                    <label className="form-label">Supplier</label>
                    <span className="text-danger">*</span>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter Supplier"
                      value={Supplier}
                      onChange={(e) => setSupplier(e.target.value)}
                      required
                    />
                  </div>

                  <div className="col-12 text-center">
                    <IconButton
                      sx={{
                        mt: 3,
                        px: 4,
                        py: 1.2,
                        borderRadius: "8px",
                        backgroundColor: "#000",
                        border: "1px solid #000",
                        color: "#fff",
                        "&:hover": {
                          backgroundColor: "#fff",
                          color: "#000",
                        },
                        fontSize: "16px",
                        fontWeight: 600,
                      }}
                      onClick={() => submit()}
                    >
                      Submit
                    </IconButton>
                  </div>
                </div>
              </form>
            </>
          ) : (
            <div
              className="d-flex justify-content-center align-items-center"
              style={{ minHeight: "200px" }}
            >
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            </div>
          )}
        </Modal.Body>
      </Modal>
    </>
  );
}

export default PurchaseOrderForm;
